// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'semitruck';

export const Component = () => (
  <path
    fill='currentColor'
    fillRule='evenodd'
    d='M1 16a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h16.665a1 1 0 0 1 .872.51l.551.98a1 1 0 0 0 .872.51h.603a1 1 0 0 1 .8.4l1.65 2.2a1 1 0 0 0 .8.4H24a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1.063a2 2 0 0 1-3.874 0h-3.126a2 2 0 0 1-3.437.823A2 2 0 0 1 9.063 16H7.937a2 2 0 0 1-3.437.823A2 2 0 0 1 1.063 16zm18.063-1a2 2 0 0 1 3.874 0H24v-2h-4.5a.5.5 0 0 1-.5-.5V9.755a1.999 1.999 0 0 1-.783-.774L17.665 8H17v7zM16 15h-.063a2 2 0 0 0-3.437-.823A2 2 0 0 0 9.063 15H7.937a2 2 0 0 0-3.437-.823A2 2 0 0 0 1.063 15H1V8h15zm-3 .5v.004a1 1 0 1 0 0-.007zm-2-1a1 1 0 0 1 1 .997v.007a1 1 0 1 1-1-1.004zm-6 1v.004a1 1 0 1 0 0-.007zm-2-1a1 1 0 0 1 1 .997v.007A1 1 0 1 1 3 14.5zM20 12h2.063l-1.5-2H20zm0 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0z'
  />
);

export const viewBox = '0 0 25 25';
